import PropTypes from 'prop-types';
import {eventTypesList} from '../constants/';

const event = PropTypes.shape({
    description: PropTypes.string,
    eventId: PropTypes.string,
    helpLink: PropTypes.string,
    helpLinkText: PropTypes.string,
    moreText: PropTypes.string,
    title: PropTypes.string.isRequired,
    type: PropTypes.oneOf(eventTypesList).isRequired,
});

const eventsByType = PropTypes.shape({
    error: PropTypes.arrayOf(event),
    warning: PropTypes.arrayOf(event),
    success: PropTypes.arrayOf(event)
});

const events = PropTypes.shape({
    canDismissEvents: PropTypes.bool,
    checksComplete: PropTypes.bool,
    errorsPresentButHidden: PropTypes.bool,
    newEvents: eventsByType,
    oldEvents: PropTypes.arrayOf(PropTypes.array),
    stats: PropTypes.shape({
        total: PropTypes.number,
    }),
});

export const commonPropTypes = {
    event,
    events,
    eventsByType,
};



// WEBPACK FOOTER //
// ./src/constants/propTypes.js